module.exports = __webpack_public_path__ + "media/jd_loading.b494ac2f.gif";